interface WhatsAppButtonProps {
  phone?: string;
}

export default function WhatsAppButton({ phone }: WhatsAppButtonProps) {
  const waNumber = phone ? phone.replace(/[^0-9]/g, "") : "972500000000";
  const waLink = `https://wa.me/${waNumber.startsWith("0") ? "972" + waNumber.slice(1) : waNumber}`;
  const url = phone ? waLink : "https://wa.me/972500000000";

  return (
    <a
      href={url}
      target="_blank"
      rel="nofollow noopener noreferrer"
      className="fixed bottom-6 left-4 z-50 w-14 h-14 flex items-center justify-center rounded-full border-[3px] border-gray-900 cursor-pointer transition-transform hover:scale-110"
      style={{
        background: "#25D366",
        boxShadow: "0 4px 12px rgba(37, 211, 102, 0.35)",
        animation: "pulse-green 2.5s infinite",
      }}
      aria-label="שלח הודעה בוואטסאפ"
    >
      <i className="ri-whatsapp-line text-white text-2xl"></i>
      <style>{`
        @keyframes pulse-green {
          0%, 100% { box-shadow: 0 4px 12px rgba(37, 211, 102, 0.35); }
          50% { box-shadow: 0 4px 20px rgba(37, 211, 102, 0.6); }
        }
      `}</style>
    </a>
  );
}
